import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './library@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="library-at-the-heart-of-our-program">
    <h1>Library at the Heart of our Program</h1>
    <p>
      The Kingston Library plays a central role in implementing the PYP program. We support our program with
      comprehensive resources both print and online. We plan and facilitate collaborative learning with every grade
      level. We strive to equip our students with literacy and research skills to become responsible lifelong learners
      through critical thinking and academic honesty.
    </p>
    <h3>Nurturing Reading</h3>
    <p>
      Reading plays a significant part in learning in Kingston community. We foster the power of reading and provide
      open access to all forms of information. Our online databases: Encyclopedia Britannica and Big Universe provide
      age appropriate and reliable sources for our inquirers to research. Students also receive free access to
      child-appropriate online news and websites. We keep our resources up to date and well rounded in support of
      research, learning and teaching needs of the community.
    </p>
    <h3>Celebrating ideas, Promoting creativity</h3>
    <p>
      Every year, we celebrate reading as a school during Book Week. Authors, illustrators and publishers give inspiring
      talks to our students to open their minds to different roles and perspectives. Students love to dress up in their
      favourite characters and share reading with one another in different grades. Our libraries provide a perfect place
      to connect our community to create and to collaborate together. We welcome everyone to indulge themselves in the
      world of books.
    </p>
    <img src={image} alt="Library at the heart of our program" />
  </ContentLayout>
);
